import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9d4e5842"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "steps" }
const _hoisted_2 = {
  key: 0,
  class: "step-triangle-1"
}
const _hoisted_3 = { class: "step-content" }
const _hoisted_4 = {
  key: 1,
  class: "step-triangle-2"
}

interface IProps {
    steps: Array<string>,
    modelValue: number;
  }
  interface IEmits {
    (event: 'update:modelValue', modelValue: number) :void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    steps: null,
    modelValue: null
  },
  emits: ["update:modelValue"],
  setup(__props: any) {

  
  


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.steps, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item,
        class: _normalizeClass(["step", { active: __props.modelValue === index, passed: __props.modelValue > index }])
      }, [
        (index > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, _toDisplayString(item), 1),
        (index + 1 !== __props.steps.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4))
          : _createCommentVNode("", true)
      ], 2))
    }), 128))
  ]))
}
}

})